import { Fragment, memo } from 'react';
import { Link } from 'react-router-dom';

import dayjs from 'dayjs';

import { formatDate } from '../../../helpers/date';
import { getEventStatus } from '../../../helpers/event';

import { DATE_FORMAT } from '../../../constants/common';

import styles from '../styles.module.scss';

import EventDetailsItem from '../DetailsItem';
import { RELATION_PATH } from '../constants';

function EventDetails({ event }) {
  const data = [
    {
      title: 'Title',
      data: event?.title
    },
    {
      title: 'Description',
      data: event?.description || '/'
    },
    {
      title: 'Start date',
      data: formatDate(event?.start_at)
    },
    {
      title: 'End date',
      data: formatDate(event?.end_at)
    },
    {
      title: 'Remind date',
      data: event?.remind_at ? dayjs(event?.remind_at).format(DATE_FORMAT.DATE) : '/'
    }
  ];

  return (
    <div className={styles['modal-view-mode']}>
      {data.map(property => (
        <EventDetailsItem key={property.title} title={property.title} data={property.data} />
      ))}

      {Array.isArray(event?.relations) && event?.relations?.length > 0 ? (
        <>
          <EventDetailsItem title="Relation" data={event?.relationType} />

          <EventDetailsItem
            title={event?.relationType}
            isDataHtml={false}
            data={event?.relations.map((r, i) => (
              <Fragment key={r.id}>
                <Link to={`/${RELATION_PATH[event?.relationType]}/${r.id}`}>{r.identifier}</Link>
                {i < event.relations.length - 1 && ', '}
              </Fragment>
            ))}
          />
        </>
      ) : (
        <EventDetailsItem title="Relations" data="/" />
      )}

      <EventDetailsItem title="Recurring type" data={event?.recurring_type || '/'} />

      {event?.recurringType ? (
        <EventDetailsItem title="Recurring end date" data={event?.recurring_end_date || '/'} />
      ) : null}

      {!event?.users?.length ? (
        <EventDetailsItem title="Users" data="/" />
      ) : (
        event?.users?.map((u, i) => {
          const status = getEventStatus(u.status);
          const statusClass = styles[status.toLowerCase()];

          return (
            <EventDetailsItem
              key={u.id}
              title={i === 0 ? 'Users' : ''}
              data={`<a href="mailto:${u.email}" class="text-lowercase">${u.email}</a> - <span class="${statusClass}">${status}</span>`}
            />
          );
        })
      )}
      {event?.external_emails?.length ? (
        <EventDetailsItem
          title="External emails"
          data={`<span class="text-lowercase">${event.external_emails.join(', ')}</span>`}
        />
      ) : (
        <EventDetailsItem title="External emails" data="/" />
      )}
    </div>
  );
}

export default memo(EventDetails);
